export default __webpack_public_path__ + "static/media/pg-10.200ed2e8.jpg";